import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import JemaatListPage from "./pages/JemaatListPage";
import JemaatFormPage from "./pages/JemaatFormPage";
import JemaatDetailPage from "./pages/JemaatDetailPage";
import KeluargaListPage from "./pages/KeluargaListPage";
import KeluargaDetailPage from "./pages/KeluargaDetailPage";
import KeluargaFormPage from "./pages/KeluargaFormPage";
import UsersPage from "./pages/UsersPage";
import AuditLogPage from "./pages/AuditLogPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import PresensiListPage from "./pages/PresensiListPage";
import PresensiSesiPage from "./pages/PresensiSesiPage";
import PresensiRekapPage from "./pages/PresensiRekapPage";
import PresensiTidakHadirPage from "./pages/PresensiTidakHadirPage";
import JemaatTerhapusPage from "./pages/JemaatTerhapusPage";
import JemaatImportPage from "./pages/JemaatImportPage";
import UlangTahunPage from "./pages/UlangTahunPage";
import PengajuanPublikPage from "./pages/PengajuanPublikPage";
import PengajuanKonfirmasiPage from "./pages/PengajuanKonfirmasiPage";
import PengajuanListPage from "./pages/PengajuanListPage";
import PengajuanDetailPage from "./pages/PengajuanDetailPage";
import CareLeaderPage from "./pages/CareLeaderPage";
import KondisiAnggotaPage from "./pages/KondisiAnggotaPage";
import PastoralAktivitasPage from "./pages/PastoralAktivitasPage";
import HouseholdPage from "./pages/HouseholdPage";
import KegiatanPage from "./pages/KegiatanPage";
import PengaturanPage from "./pages/PengaturanPage";
import ExportBackupPage from "./pages/ExportBackupPage";
import DataAnakPage from "./pages/DataAnakPage";
import PresensiAnakPage from "./pages/PresensiAnakPage";
import PresensiAnakSesiPage from "./pages/PresensiAnakSesiPage";
import UlangTahunAnakPage from "./pages/UlangTahunAnakPage";
import PerpustakaanPage from "./pages/PerpustakaanPage";
import ArsipPage from "./pages/ArsipPage";
import TemplateUcapanPage from "./pages/TemplateUcapanPage";
import StrukturPage from "./pages/StrukturPage";
import PengumumanPage from "./pages/PengumumanPage";
import KunjunganDaftarPage from "./pages/KunjunganDaftarPage";
import KunjunganPage from "./pages/KunjunganPage";
import JadwalPelayananPage from "./pages/JadwalPelayananPage";
import RekapPelayanPage from "./pages/RekapPelayanPage";

const P = ({ perm, children }) => <ProtectedRoute perm={perm}><Layout>{children}</Layout></ProtectedRoute>;
// Beranda: role tanpa dashboard diarahkan ke halaman pertama yang diizinkan.
const FALLBACK_HOME = [["presensi:read", "/presensi"], ["anak:read", "/data-anak"], ["presensi_anak:read", "/presensi-anak"], ["perpustakaan:read", "/perpustakaan"], ["arsip:read", "/arsip"], ["jemaat:read", "/jemaat"], ["care_leader:read", "/care-leader"], ["kunjungan:read", "/kunjungan"]];
const homeFor = (can) => (can("dashboard:read") ? "/" : (FALLBACK_HOME.find(([p]) => can(p)) || [null, "/"])[1]);
const HomeRoute = () => {
  const { user, ready, can } = useAuth();
  const tujuan = homeFor(can);
  if (ready && user && tujuan !== "/") return <Navigate to={tujuan} replace />;
  return <P perm="dashboard:read"><DashboardPage /></P>;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/formulir" element={<PengajuanPublikPage />} />
            <Route path="/formulir/konfirmasi" element={<PengajuanKonfirmasiPage />} />
            <Route path="/ajukan-pelayanan" element={<Navigate to="/formulir" replace />} />
            <Route path="/ajukan-pelayanan/konfirmasi" element={<Navigate to="/formulir" replace />} />
            <Route path="/pengajuan-pelayanan" element={<P perm="pengajuan:read"><PengajuanListPage /></P>} />
            <Route path="/pengajuan-pelayanan/:id" element={<P perm="pengajuan:read"><PengajuanDetailPage /></P>} />
            <Route path="/" element={<HomeRoute />} />
            <Route path="/jemaat" element={<P perm="jemaat:read"><JemaatListPage /></P>} />
            <Route path="/jemaat/tambah" element={<P perm="jemaat:write"><JemaatFormPage /></P>} />
            <Route path="/jemaat/import" element={<P perm="jemaat:write"><JemaatImportPage /></P>} />
            <Route path="/jemaat/:id" element={<P perm="jemaat:read"><JemaatDetailPage /></P>} />
            <Route path="/jemaat/:id/edit" element={<P perm="jemaat:write"><JemaatFormPage /></P>} />
            <Route path="/keluarga" element={<P perm="keluarga:read"><KeluargaListPage /></P>} />
            <Route path="/household" element={<P perm="household:read"><HouseholdPage /></P>} />
            <Route path="/keluarga/tambah" element={<P perm="keluarga:write"><KeluargaFormPage /></P>} />
            <Route path="/keluarga/:id" element={<P perm="keluarga:read"><KeluargaDetailPage /></P>} />
            <Route path="/keluarga/:id/edit" element={<P perm="keluarga:write"><KeluargaFormPage /></P>} />
            <Route path="/jemaat/terhapus" element={<P perm="jemaat:delete"><JemaatTerhapusPage /></P>} />
            <Route path="/presensi" element={<P perm="presensi:read"><PresensiListPage /></P>} />
            <Route path="/jadwal-pelayanan" element={<P perm="jadwal:read"><JadwalPelayananPage /></P>} />
            <Route path="/ulang-tahun" element={<P perm="jemaat:read"><UlangTahunPage /></P>} />
            <Route path="/care-leader" element={<P perm="care_leader:read"><CareLeaderPage /></P>} />
            <Route path="/kunjungan" element={<P perm="kunjungan:read"><KunjunganPage /></P>} />
            <Route path="/kunjungan/daftar" element={<P perm="kunjungan:read"><KunjunganDaftarPage /></P>} />
            <Route path="/kondisi-anggota" element={<P perm="kondisi:read"><KondisiAnggotaPage /></P>} />
            <Route path="/pastoral/aktivitas" element={<P perm="care_leader:read"><PastoralAktivitasPage /></P>} />
            <Route path="/presensi/rekap" element={<P perm="presensi:read"><PresensiRekapPage /></P>} />
            <Route path="/presensi/rekap-pelayan" element={<P perm="jadwal:read"><RekapPelayanPage /></P>} />
            <Route path="/presensi/tidak-hadir" element={<P perm="presensi:read"><PresensiTidakHadirPage /></P>} />
            <Route path="/presensi/:id" element={<P perm="presensi:read"><PresensiSesiPage /></P>} />
            <Route path="/users" element={<P perm="users:manage"><UsersPage /></P>} />
            <Route path="/audit-log" element={<P perm="audit:read"><AuditLogPage /></P>} />
            <Route path="/kegiatan" element={<P perm="kegiatan:read"><KegiatanPage /></P>} />
            <Route path="/pengaturan" element={<P perm="pengaturan:write"><PengaturanPage /></P>} />
            <Route path="/pengaturan/ucapan" element={<P perm="ucapan:manage"><TemplateUcapanPage /></P>} />
            <Route path="/pengaturan/backup" element={<P perm="backup:export"><ExportBackupPage /></P>} />
            <Route path="/data-anak" element={<P perm="anak:read"><DataAnakPage /></P>} />
            <Route path="/presensi-anak" element={<P perm="presensi_anak:read"><PresensiAnakPage /></P>} />
            <Route path="/presensi-anak/:id" element={<P perm="presensi_anak:read"><PresensiAnakSesiPage /></P>} />
            <Route path="/ulang-tahun-anak" element={<P perm="anak:read"><UlangTahunAnakPage /></P>} />
            <Route path="/perpustakaan" element={<P perm="perpustakaan:read"><PerpustakaanPage /></P>} />
            <Route path="/arsip" element={<P perm="arsip:read"><ArsipPage /></P>} />
            <Route path="/struktur-organisasi" element={<P perm="dashboard:read"><StrukturPage /></P>} />
            <Route path="/pengumuman" element={<P perm="dashboard:read"><PengumumanPage /></P>} />
            <Route path="/ganti-password" element={<P><ChangePasswordPage /></P>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
